import styled from "styled-components";

import { Button, SVGSprite } from "../../Atoms";
import Typography from "../../../foundation/Typography/V2";

export const PrimaryCTA = styled(Button)`
  margin-right: 8px;
  padding: 11px 32px;
  box-shadow: 0px 10px 20px
      rgba(${({ theme }) => theme.colors.shadows.purple_3}, 0.18),
    0px 2px 6px rgba(${({ theme }) => theme.colors.shadows.purple_3}, 0.12),
    0px 0px 1px rgba(${({ theme }) => theme.colors.shadows.black}, 0.04);
  &:last-child {
    margin-right: 0;
  }
  @media only screen and (max-width: 992px) {
    line-height: 32px;
    padding: 9px 24px;
  }
`;

export const SecondaryCTA = styled(PrimaryCTA)`
  padding-right: 16px;
  padding-left: 40px;
  width: fit-content;
  p {
    display: flex;
    align-items: center;
  }
  @media only screen and (max-width: 992px) {
    padding: 8px 8px 8px 32px;
  }
`;

export const Span = styled(Typography)`
  height: 32px;
  width: 32px;
  border-radius: 50%;
  margin-left: 24px;
  background-color: ${({ theme }) => theme.colorsV2.primary.shade_800};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowRight = styled(SVGSprite)`
  fill: ${({ theme }) => theme.colors.white};
  height: 16px;
  width: 16px;
`;
